var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification)?_c('div',{staticClass:"header-cart-notification"},[_c('oie-cart-product-item-notification',{attrs:{"cart-row":_vm.notification.meta,"close-notification-handler":_vm.desmissNotification}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }